define('all/pixel-tracking',['module', 'jquery'], function(module, $) {
	'use strict';

	var configuration = module.config();
	var pt = {
		addPixelTrack: function(page) {
			var tag = configuration[page];
			if(tag !== undefined) {
				$(document.body).append(tag);
			} else {
				console.warn('No pixel tracking tag for page ' + page);
			}
		}
	};

	return pt;

});

